import {Injectable} from '@angular/core';
import {ApiService} from "@common-lib";
import {map} from "rxjs/operators";
import {ApiResponse} from "../common/services/api.service";

export interface AnalyticsDataItem {
    label: string,
    data: Array<{
        date: string,
        amount: number
    }>,
    total: number
}

export interface AnalyticsCommonDataItem extends Array<{
    name: string,
    amount: number,
    category?: string
    product?: string
}> {}

export interface AnalyticsData {
    main: {
        visitors: AnalyticsDataItem
        configurations: AnalyticsDataItem,
        sessionDuration: AnalyticsDataItem,
        configurationsPerSession: AnalyticsDataItem,
        configurationsPerVisitor: AnalyticsDataItem,
        sessionsPerVisitor: AnalyticsDataItem,
        savedConfigurations: AnalyticsDataItem
    },
    common: {
        variants: AnalyticsCommonDataItem,
        countries: AnalyticsCommonDataItem,
        browsers: AnalyticsCommonDataItem,
        devices: AnalyticsCommonDataItem
    }
}

export enum TimeInterval{
    RealTime,
    Hour,
    Day,
    Week,
    Month,
    Year
}

export const AnalyticsDataLabels = {
    visitors: 'webpanel.analytics.visitors',
    configurations: 'webpanel.analytics.configurations',
    sessionDuration: 'webpanel.analytics.session_duration',
    configurationsPerSession: 'webpanel.analytics.configurations_per_session',
    configurationsPerVisitor: 'webpanel.analytics.configurations_per_session',
    sessionsPerVisitor: 'webpanel.analytics.sessions_per_visitor',
    savedConfigurations: 'webpanel.analytics.savedConfigurations'
};

@Injectable()
export class AnalyticsDashboardService {

    constructor(private api: ApiService) {
    }


    loadAggregatedStats(interval: TimeInterval, filters?: any) {

        return this.api.get(`/admin/dashboard/${interval}`).pipe(
            map((resp: ApiResponse) => resp.result as AnalyticsData)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/services/analytics-dashboard.service.ts